<div class="filter-option">
  Pin to
</div>
<ul class="filter-list-item">
  <li>
    @for (colPin of pinToArray; track colPin) {
      <div class="form-check">
        <input class="form-check-input" type="radio" [id]="field+colPin.id" [(ngModel)]="selectedPosition" [value]="field+colPin.id" (click)="pinColumn(colPin.id)">
        <label class="form-check-label" [for]="field+colPin.id">
          {{colPin.name}}
        </label>
      </div>
    }
  </li>
</ul>
<div class="filter-action text-right">
  <span class="'filter-reset'">
    <button class="btn btn-sm btn-primary" (click)="reset()">Reset Filter</button>
  </span>
</div>
